/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable object-curly-newline */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import Box from "@mui/material/Box";

import { getCssUrl } from "../../../../logic/utility/thumbnailUtil";

export interface CareerCardProps {
    thumbnail?: string;
}

const ThumbnailBox = (props: CareerCardProps) => {
    const { thumbnail } = props;
    const [thumbnailUrl, setThumbnailUrl] = React.useState(getCssUrl());

    React.useEffect(() => {
        setThumbnailUrl(getCssUrl(thumbnail));
    }, [thumbnail]);

    return (
        <Box
            sx={{
                height: "100%",
                backgroundImage: thumbnailUrl,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                borderRadius: "5px",
                aspectRatio: "16/9",
            }}
        />
    );
};

export default ThumbnailBox;
